import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageSquare } from "lucide-react";
import logoAsset from "@/assets/rc-chemical-lab-logo.png.asset.json";

const Footer = () => {
  return (
    <footer className="gradient-navy text-primary-foreground">
      {/* Compliance banner */}
      <div className="border-b border-primary-foreground/10 py-3">
        <div className="container mx-auto px-4 text-center text-xs opacity-90">
          ⚠️ All products are for laboratory and research use only. Not for human consumption. By purchasing, you agree to our terms of use and confirm compliance with all applicable regulations.
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4 bg-white rounded-md p-3 inline-block shadow-md">
              <img src={logoAsset.url} alt="RC Chemical Lab" className="h-20 w-auto max-w-[320px] object-contain" />
            </div>
            <p className="text-sm opacity-90 mb-4">
              We supply Laboratory Chemicals, Research Chemicals, Industrial Chemicals, Pills & Painkillers, Medical Cannabis, and Liquid Mercury for professional and industrial use.
            </p>
            <div className="space-y-2 text-sm opacity-90">
              <div className="flex items-center gap-2"><Mail className="h-3.5 w-3.5" /> info@rcchemicallab.com</div>
              <div className="flex items-center gap-2"><Phone className="h-3.5 w-3.5" /> Text: +1 (458) 888-9647</div>
              <div className="flex items-center gap-2"><MessageSquare className="h-3.5 w-3.5" /> Telegram: @chemwayusa</div>
              <div className="flex items-start gap-2"><MapPin className="h-3.5 w-3.5 mt-0.5" /> 65 Zub Lane, Gardner, MA 01440 USA</div>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider">Products</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li><Link to="/research-chemicals" className="hover:opacity-100 transition-opacity">Research Chemicals</Link></li>
              <li><Link to="/industrial-chemicals" className="hover:opacity-100 transition-opacity">Industrial Chemicals</Link></li>
              <li><Link to="/liquid-mercury" className="hover:opacity-100 transition-opacity">Liquid Mercury</Link></li>
              <li><Link to="/pills-painkillers" className="hover:opacity-100 transition-opacity">Pills & Painkillers</Link></li>
              <li><Link to="/cannabis" className="hover:opacity-100 transition-opacity">Medical Cannabis</Link></li>
              <li><Link to="/nootropics" className="hover:opacity-100 transition-opacity">Nootropics</Link></li>
              <li><Link to="/peptides" className="hover:opacity-100 transition-opacity">Peptides</Link></li>
              <li><Link to="/shop" className="hover:opacity-100 transition-opacity">Shop All</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider">Support</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li><Link to="/about" className="hover:opacity-100 transition-opacity">About Us</Link></li>
              <li><Link to="/blog" className="hover:opacity-100 transition-opacity">Blog</Link></li>
              <li><Link to="/documentation" className="hover:opacity-100 transition-opacity">Documentation (COA/SDS)</Link></li>
              <li><Link to="/shipping" className="hover:opacity-100 transition-opacity">Shipping & Returns</Link></li>
              <li><Link to="/bulk-orders" className="hover:opacity-100 transition-opacity">Bulk & B2B Inquiries</Link></li>
              <li><Link to="/support" className="hover:opacity-100 transition-opacity">Technical Support</Link></li>
              <li><Link to="/contact" className="hover:opacity-100 transition-opacity">Contact Us</Link></li>
              <li><Link to="/faq" className="hover:opacity-100 transition-opacity">FAQ</Link></li>
            </ul>
          </div>

          {/* Compliance */}
          <div>
            <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider">Compliance</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li><Link to="/terms" className="hover:opacity-100 transition-opacity">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:opacity-100 transition-opacity">Privacy Policy</Link></li>
              <li><Link to="/quality" className="hover:opacity-100 transition-opacity">Quality Assurance</Link></li>
              <li><Link to="/quality" className="hover:opacity-100 transition-opacity">Certifications</Link></li>
              <li><Link to="/terms" className="hover:opacity-100 transition-opacity">Regulatory Compliance</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs opacity-80">
          <p>© 2026 RC Chemical Labs. All rights reserved.</p>
          <div className="flex gap-4">
            <span>ISO 9001:2015 Certified</span>
            <span>•</span>
            <span>cGMP Compliant</span>
            <span>•</span>
            <span>DEA Licensed</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
